import { FULL_CIRCLE } from '../../cameraAngle/constants';

export { FULL_CIRCLE };

/** Fal has no per-keyframe azimuth limit; two turns each way keeps the slider usable. Total travel is capped below. */
export const CAMERA_MOTION_AZIMUTH = { max: FULL_CIRCLE * 2, min: -FULL_CIRCLE * 2 } as const;
/** Fal rejects paths whose azimuth changes add up to more than this many full turns. */
export const CAMERA_MOTION_MAX_AZIMUTH_TURNS = 32;
export const CAMERA_MOTION_MAX_AZIMUTH_TRAVEL = FULL_CIRCLE * CAMERA_MOTION_MAX_AZIMUTH_TURNS;
export const CAMERA_MOTION_ELEVATION = { max: 90, min: -90 } as const;
/** Fal only requires distance above 0 and sets no maximum. */
export const CAMERA_MOTION_DISTANCE = { max: 3, min: 0.1, step: 0.05 } as const;

export const CAMERA_MOTION_MAX_KEYFRAMES = 12;
export const CAMERA_MOTION_MIN_KEYFRAMES = 2;
/** Middle marks stay this far apart, as a fraction of the clip, so they cannot stack. */
export const CAMERA_MOTION_KEYFRAME_TIME_GAP = 0.02;
/** Fal accepts 0.92 to 15 seconds; the menu offers whole seconds in that range. */
const CAMERA_MOTION_DURATION_RANGE = { max: 15, min: 1 } as const;
export const CAMERA_MOTION_DURATIONS: readonly number[] = Array.from(
  { length: CAMERA_MOTION_DURATION_RANGE.max - CAMERA_MOTION_DURATION_RANGE.min + 1 },
  (_, index) => CAMERA_MOTION_DURATION_RANGE.min + index,
);
export const DEFAULT_CAMERA_MOTION_DURATION = 5;

export const CAMERA_MOTION_RESOLUTIONS = [
  { description: 'Fastest', id: '480P', label: '480p' },
  { description: 'Sharper', id: '768P', label: '768p' },
  { description: 'Refined from 768p', id: '1080P', label: '1080p' },
] as const;
export type CameraMotionResolution = (typeof CAMERA_MOTION_RESOLUTIONS)[number]['id'];
export const DEFAULT_CAMERA_MOTION_RESOLUTION: CameraMotionResolution = '768P';
export const isCameraMotionResolution = (value: string): value is CameraMotionResolution =>
  CAMERA_MOTION_RESOLUTIONS.some((option) => option.id === value);

export const CAMERA_MOTION_DRAG_SENSITIVITY = 0.8;
/** Distance change per pixel of wheel scroll on the globe. */
export const CAMERA_MOTION_WHEEL_SENSITIVITY = 0.002;

/** Panel width (584) plus the node gap and edge padding, so the panel flips left before it would cover the clip. */
export const CAMERA_MOTION_MIN_SIDE_SPACE = 624;

export const isCameraMotionDuration = (value: number): boolean =>
  Number.isInteger(value) && value >= CAMERA_MOTION_DURATION_RANGE.min && value <= CAMERA_MOTION_DURATION_RANGE.max;

export const clampCameraMotionValue = (value: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, value));
